(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pgf-deferred-signup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pgf-deferred-signup')) {
customElements.define('pgf-deferred-signup', class extends HTMLElement {
connectedCallback() {
if(this.connected)return;this.connected=true;
if(new URLSearchParams(window.location.search).get('shop_sign_in')==='true'){this.load();}
else if('IntersectionObserver' in window){this.visibilityObserver=new IntersectionObserver((entries)=>{if(entries.some((entry)=>entry.isIntersecting)){this.visibilityObserver.disconnect();this.load();}},{rootMargin:'1000px 0px'});this.visibilityObserver.observe(this);}else{this.load();}
}
async load(){
if(this.started)return;this.started=true;
const mount=this.querySelector('[data-signup-mount]');const status=this.querySelector('[data-signup-status]');const formId=this.dataset.formId;const source=new URL(this.dataset.source,window.location.origin);
try{
if(source.origin!==window.location.origin)throw new Error('Unexpected signup source');
if(document.querySelector('script[src*="/shopify-forms-loader"]'))throw new Error('Forms already initialized');
const response=await fetch(source,{credentials:'same-origin',signal:AbortSignal.timeout(15000)});if(!response.ok)throw new Error('Signup source unavailable');
const parsed=new DOMParser().parseFromString(await response.text(),'text/html');
const root=parsed.querySelector('[data-form-root="true"][data-forms-id="forms-root-'+formId+'"]');
const scriptSource=Array.from(parsed.scripts).find((script)=>{if(!script.src)return false;const candidate=new URL(script.getAttribute('src'),source);return candidate.protocol==='https:'&&candidate.hostname==='cdn.shopify.com'&&candidate.pathname.startsWith('/extensions/')&&candidate.pathname.endsWith('/shopify-forms-loader.js');});
const contextNode=parsed.getElementById('pgf-signup-context');if(!root||!scriptSource||!contextNode)throw new Error('Incomplete native signup source');
if(document.querySelector('script[src*="/shopify-forms-loader"]'))throw new Error('Forms initialized during source request');
const context=JSON.parse(contextNode.textContent);window.ShopifyForms={...window.ShopifyForms,currentPageType:context.currentPageType};if(context.customer)window.ShopifyForms.customer=context.customer;
const adoptedRoot=document.importNode(root,true);mount.replaceChildren(adoptedRoot);
const checkReady=()=>{const host=adoptedRoot.querySelector('shopify-forms-embed');if(!host||!host.shadowRoot)return;if(!this.shadowObserver){this.shadowObserver=new MutationObserver(checkReady);this.shadowObserver.observe(host.shadowRoot,{childList:true,subtree:true});}if(host.shadowRoot.querySelector('input, button')){status.hidden=true;this.dataset.loadState='ready';this.rootObserver.disconnect();this.shadowObserver.disconnect();}};
this.rootObserver=new MutationObserver(checkReady);this.rootObserver.observe(adoptedRoot,{childList:true,subtree:true});
const loader=document.createElement('script');loader.src=new URL(scriptSource.getAttribute('src'),source).href;loader.async=true;loader.addEventListener('error',()=>{this.dataset.loadState='failed';},{once:true});this.dataset.loadState='loading';document.head.append(loader);
}catch(error){this.dataset.loadState='failed';this.dataset.loadError=error.message;}
}
});}

  } catch(e) { console.error(e); }
})();
})();
